import {
  Component,
  ContentChildren,
  Input,
  QueryList,
  Output,
  EventEmitter,
  forwardRef,
  AfterContentInit,
  OnInit,
  Inject,
} from '@angular/core';
import { CarouselDirective } from './carousel.directive';
import { animate, style, trigger, transition, query, stagger } from '@angular/animations';
import { CareAnalyticsService } from '../../services/care-analytics.service';
import { LIB_CONFIG } from '../../lib-config';
import { LibConfig } from '../../models/lib-config.model';

@Component({
  selector: 'vm-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition('* => *', [
        query(':enter', [style({ opacity: 0 }), stagger(10, [animate('0.7s', style({ opacity: 1 }))])], {
          optional: true,
        }),
      ]),
    ]),
  ],
})
export class CarouselComponent implements AfterContentInit, OnInit {
  @Input() timing = '250ms ease-in';
  @Input() showControls = true;
  @Input() showPips = true;
  @Input() nextButtonClasses = 'button-secondary';
  @Input() prevButtonClasses = 'button-tertiary-outline';
  @Input() nextCopy = 'Next';
  @Input() prevCopy = 'Previous';
  @Input() backButtonCopy = 'Back';
  @Input() doneButtonCopy = 'Done';

  @Output() slideEvent: EventEmitter<number> = new EventEmitter();
  @Output() backButtonClick = new EventEmitter();
  @Output() doneButtonClick = new EventEmitter();

  @ContentChildren(forwardRef(() => CarouselDirective), {
    descendants: true,
  })
  slides: QueryList<CarouselDirective>;

  slidesList = [];
  carouselWrapperStyle = {};
  currentNextCopy = '';
  currentPrevCopy = '';

  private currentSlideIndex = 0;

  constructor(private careAnalyticsService: CareAnalyticsService, @Inject(LIB_CONFIG) private config: LibConfig) {
    this.careAnalyticsService.pageIndex = 1;
  }

  ngOnInit(): void {
    this.currentNextCopy = this.nextCopy;
    this.currentPrevCopy = this.backButtonCopy;
  }

  ngAfterContentInit() {
    this.setSlides();
    this.showPips = this.slides?.length > 1;
    this.setButtonCopy();
  }

  setSlides() {
    this.slidesList = this.slides.toArray();
  }

  next() {
    if (this.isLastSlide()) {
      this.careAnalyticsService.pageIndex = null;
      this.doneButtonClick.emit();
      return;
    } else {
      this.currentSlideIndex = (this.currentSlideIndex + 1) % this.slides.length;
      this.setButtonCopy();
    }
    this.careAnalyticsService.pageIndex = this.currentSlideIndex + 1;
    this.careAnalyticsService.trackPageView(this.config.appName === 'tv-fault' ? 'tv-faults' : this.config.appName, 1);
    this.slideEvent.emit(this.currentSlideIndex);
  }

  prev() {
    if (this.isFirstSlide()) {
      this.careAnalyticsService.pageIndex = null;
      this.backButtonClick.emit();
      return;
    } else {
      this.currentSlideIndex = (this.currentSlideIndex - 1 + this.slides.length) % this.slides.length;
      this.setButtonCopy();
    }
    this.careAnalyticsService.pageIndex = this.currentSlideIndex + 1;
    this.careAnalyticsService.trackPageView(this.config.appName === 'tv-fault' ? 'tv-faults' : this.config.appName, 1);
    this.slideEvent.emit(this.currentSlideIndex);
  }

  get activeSlide() {
    return this.currentSlideIndex;
  }

  private setButtonCopy() {
    if (this.isLastSlide()) {
      this.currentNextCopy = this.doneButtonCopy;
    } else {
      this.currentNextCopy = this.nextCopy;
    }

    if (this.isFirstSlide()) {
      this.currentPrevCopy = this.backButtonCopy;
    } else {
      this.currentPrevCopy = this.prevCopy;
    }
  }

  private isFirstSlide() {
    return this.currentSlideIndex === 0;
  }

  private isLastSlide() {
    return this.currentSlideIndex + 1 === this.slides?.length;
  }
}
